import dayjs from 'dayjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformResponse(response: any): any {
  if (!response) return response;

  if (Array.isArray(response)) {
    return response.map(item => transformResponse(item));
  }

  if (typeof response === 'object') {
    const transformed = { ...response };

    for (const key in transformed) {
      if (Object.prototype.hasOwnProperty.call(transformed, key)) {
        const lowerCaseKey = key.toLowerCase();

        // The heuristic is a name match, so anything with "time" in it gets parsed as a date.
        // `reminderTimeOfDay` holds a clock time ("12:00"), which dayjs cannot parse: it came
        // back as an Invalid Date object and crashed React the moment a component rendered it
        // ("Objects are not valid as a React child" — Sentry 132533755, bien Belharra).
        const isDateField =
          lowerCaseKey !== 'timezone' &&
          lowerCaseKey !== 'daytimeforecast' &&
          lowerCaseKey !== 'remindertimeofday' &&
          (lowerCaseKey.includes('time') ||
            lowerCaseKey.includes('date') ||
            lowerCaseKey.includes('lastmodified') ||
            lowerCaseKey.includes('submittedat') ||
            lowerCaseKey.includes('dtstart') ||
            lowerCaseKey.includes('paidat') ||
            lowerCaseKey.includes('createdat') ||
            lowerCaseKey.includes('until'));

        if (isDateField) {
          transformed[key] = transformed[key] === null ? null : dayjs(transformed[key]);
        } else {
          transformed[key] = transformResponse(transformed[key]);
        }
      }
    }
    return transformed;
  }

  return response;
}
